var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Sidebar",
    {
      staticClass: "test",
      attrs: { "props-handle-click-close": _vm.toggleSidebar },
    },
    [
      _c("TitleBlock", { attrs: { text: "MyPC", type: "alternative" } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "profile-sidebar section section-border--top section-border--right",
        },
        [
          _c(
            "div",
            { staticClass: "profile-sidebar__wrapper" },
            [
              _vm._l(_vm.profileMenu.submenu, function (item, index) {
                return [
                  !item.toolsAccessRequired ||
                  (item.toolsAccessRequired && _vm.hasAccessTools)
                    ? _c(
                        "nuxt-link",
                        {
                          key: index,
                          staticClass: "profile-sidebar__item",
                          attrs: { to: item.link },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.title) + "\n          "
                          ),
                          _vm.watchlist && item.title === "Watchlist"
                            ? _c("span", { staticClass: "counter" }, [
                                _vm._v(_vm._s(_vm.watchlist.length)),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }